import React from 'react';
import './InstanceDialog.css';

interface TokenDialogProps {
  show: boolean;
  editingId: string | null;
  formData: {
    name: string;
    active: boolean;
  };
  onSubmit: (e: React.FormEvent) => void;
  onChange: (data: { name?: string; active?: boolean }) => void;
  onClose: () => void;
}

function TokenDialog({ show, editingId, formData, onSubmit, onChange, onClose }: TokenDialogProps) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content edit-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>{editingId ? '✏️ Editar Token' : '➕ Gerar Novo Token'}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form id="token-form" onSubmit={onSubmit} className="dialog-form">
          <div className="form-grid">
            <div className="form-group">
              <label>Nome:</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => onChange({ name: e.target.value })}
                placeholder="Ex: Integração ERP"
                required
              />
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.active}
                  onChange={(e) => onChange({ active: e.target.checked })}
                />
                <span>Token ativo</span>
              </label>
            </div>
          </div>
        </form>

        <div className="dialog-actions">
          <button type="submit" form="token-form" className="btn-primary">
            💾 {editingId ? 'Salvar' : 'Criar'}
          </button>
          <button 
            type="button" 
            className="btn-secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default TokenDialog;

